var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "eu-text-overflow emd-copy",
      class: { _copied: _vm.copied, "eu-row_reverse": _vm.textLeft },
      on: {
        click: function ($event) {
          return _vm.copy(_vm.item)
        },
      },
    },
    [
      _c(
        "span",
        {
          staticClass: "emd-copy__icon",
          attrs: { title: _vm.copied ? _vm.$t("copied") : _vm.$t("copy") },
        },
        [
          _vm.copied
            ? _c("i", { staticClass: "uil uil-check-circle" })
            : _c("i", { staticClass: "uil uil-copy" }),
        ]
      ),
      _c("p", { staticClass: "er-copy__text emd-copy__text" }, [
        _c(
          "span",
          [_vm.showLabel ? [_vm._v(" " + _vm._s(_vm.item) + " ")] : _vm._e()],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }